/**
 * Redstone RGS Provider Configuration
 * Provider-specific win thresholds, types, and settings
 */

export const PROVIDER_CONFIG = {
  // Provider identification
  PROVIDER_NAME: "Redstone",
  GAME_NAME: "fairys-secret",
  CURRENCY: "FUN",

  // Win thresholds (multiplier of bet size)
  WIN_THRESHOLDS: {
    SMALL_WIN_THRESHOLD: 0.1, // 0.1x - 4.99x
    MEDIUM_WIN_THRESHOLD: 5, // 5x - 9.99x
    LARGE_WIN_THRESHOLD: 10, // 10x - 14.99x
    BIG_WIN_THRESHOLD: 15, // 15x - 29.99x
    MEGA_WIN_THRESHOLD: 30, // 30x - 49.99x
    SUPER_WIN_THRESHOLD: 50, // 50x - 99.99x
    EPIC_WIN_THRESHOLD: 100, // 100x+
  },

  // Win type constants
  WIN_TYPES: {
    SMALL_WIN: "small_win",
    MEDIUM_WIN: "medium_win",
    LARGE_WIN: "large_win",
    BIG_WIN: "big_win",
    MEGA_WIN: "mega_win",
    SUPER_WIN: "super_win",
    EPIC_WIN: "epic_win",
  },

  // Which wins trigger animated celebrations (full-screen win animation)
  ANIMATED_WIN_TYPES: ["big_win", "mega_win", "super_win", "epic_win"],

  // Error code mappings - Maps Redstone error codes to universal error codes
  // Universal codes are based on PopiPlay's numeric system for consistency
  ERROR_CODES: {
    INSUFFICIENT_BALANCE: 301, // Not enough money (maps to PopiPlay's 301)
    INVALID_SESSION: 401, // Session expired/invalid
    INVALID_TOKEN: 401, // Token expired/invalid (same as session)
    GAME_UNAVAILABLE: 500, // Server error / game unavailable
    MAINTENANCE: 503, // Server maintenance
    INVALID_BET: 400, // Invalid bet amount
    // Add more Redstone error codes as needed
  },
};
